import React from "react";
import {IProduct} from 'data/interfaces/products';
import AdInfo from 'gui/pages/mainRouter/pages/ad/components/commons/adInfo';
import AdDateBetween
  from 'gui/components/listPage/components/ad/components/adDateBetween';
import AdOpeningHours from "gui/components/listPage/components/ad/components/adOpeningHours/AdOpeningHours";

interface IVoucherInfoProps {
  product: Partial<IProduct>;
  className?: string;
  title?: string;
  hideTitle?: boolean;
  additionalDetails?: any;
}

const VoucherInfo = (props: IVoucherInfoProps) => (
  <AdInfo {...props}>
    <AdDateBetween
      endDateText="תאריך סיום תוקף"
      endDate={props.product.voucherDetails.expiration}
    />
    <AdOpeningHours placeDetails={props.product.placeDetails}/>
    {props.additionalDetails}
  </AdInfo>
);

VoucherInfo.defaultProps = {
  product: {},
  title: 'מידע:',
  className: '',
  additionalDetails: null,
};

export default VoucherInfo;
